
import { useState } from 'react';
import { Api } from '@/services';
import { showToast } from '@/utils';
interface SellerAntecipationRequest {
  amount: number;
}

interface SellerAntecipationResponse {
  amount: number;
  status: string;
}

interface SellerRateSimulator {
  netAmount: number;
  grossAmount: number;
  anticipationDate: string;
  effectiveRate: number;
}
export function useAntecipation() {

  const baseUrlAntecipation = '/seller/antecipation/rate';
  const baseUrl = "/email-messages/revenue-anticipation";
const [loading,setLoading]= useState<Boolean>(false);
  
  const responsePostAntecipation = {
    "amount": 1000
  }
  
  const postAntecipation = (data: any) => {
    return Api.post(`${baseUrl}`, data);
  };
  
  const simulateAnticipation = async (amount: number) => {
    setLoading(true)
    try {
      const response = await Api.get<SellerRateSimulator>(`${baseUrlAntecipation}?amount=${amount}`);
    
      return response.data
    } catch (error) {
      showToast({
        type: 'error',
        message: 'Erro ao simular antecipação.',
      });
    }finally {
      setLoading(false)
    }
  };

  const confirmAnticipation = async (data: SellerAntecipationRequest) => {
    setLoading(true)
    try {
      const response = await Api.post<SellerAntecipationResponse>(baseUrlAntecipation, data);
      showToast({
        type: 'success',
        message: response.data.status,
      });
     return response.data
    } catch (error) {
      showToast({
        type: 'error',
        message: 'Erro ao confirmar antecipação.',
      });
    }finally {
      setLoading(false)
    }
  };

  return {
    postAntecipation,
    simulateAnticipation,
    confirmAnticipation,
    loading
  
  };
}
